import {
    UniaGAVConstants
} from "@/assets/configuration/constants.js";

export {
    loadMerkliste,
    saveMerkliste,
    addItemToMerkliste,
    addItemsToMerkliste,
    removeSingleItemFromMerkliste,
    removeAllItemsFromMerkliste
};

function loadMerkliste() {

    var bookmarks = window.localStorage.getItem(
        UniaGAVConstants.LocalStorageKeys.AdminMerkliste
    );

    if(bookmarks){
        return JSON.parse(bookmarks);
    }
    else{
        removeAllItemsFromMerkliste();
        return [];
    }
    
}

function removeAllItemsFromMerkliste() {

    var currentMerkliste = [];
    saveMerkliste(currentMerkliste);
    return currentMerkliste;
}

function saveMerkliste(merkliste) {
    window.localStorage.setItem(
        UniaGAVConstants.LocalStorageKeys.AdminMerkliste,
        JSON.stringify(merkliste)
    );

    return loadMerkliste();
}

function removeSingleItemFromMerkliste(index) {
    var currentMerkliste = loadMerkliste();
    currentMerkliste.splice(index, 1);
    saveMerkliste(currentMerkliste);
    return currentMerkliste;
}

function addItemToMerkliste(contractName, versionNumber, editionNumber, contractNumber) {

    var newItem = {
        DisplayName: contractName,
        Version: versionNumber,
        Edition: editionNumber,
        GavNumber: contractNumber
    };

    var currentMerkliste = loadMerkliste();

    var existingItem = currentMerkliste.filter(item => {
        return (item.GavNumber == newItem.GavNumber && item.Version == newItem.Version && item.Edition == newItem.Edition);
    });

    if (existingItem.length > 0) {
        return -1;
    }

    currentMerkliste.push(newItem);
    saveMerkliste(currentMerkliste);

    return 1;
}

function addItemsToMerkliste(items) {
    
    var currentMerkliste = loadMerkliste();

    items.forEach(item => {
        var newItem = {
            DisplayName: item.contractName,
            Version: item.versionNumber,
            Edition: item.editionNumber,
            GavNumber: item.contractNumber
        };

        var existingItem = currentMerkliste.filter(item => {
            return (item.GavNumber == newItem.GavNumber && item.Version == newItem.Version && item.Edition == newItem.Edition);
        });

        if (existingItem.length == 0) {
            currentMerkliste.push(newItem);
        }
    });

    saveMerkliste(currentMerkliste);
    return currentMerkliste;
}